import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-navy text-white py-8 md:py-16 px-4" data-id="element-77">
      <div className="max-w-4xl mx-auto" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-79">
          <div className="space-y-4 md:space-y-6 text-base md:text-lg leading-relaxed mb-8 md:mb-12" data-id="element-80">
            <p data-id="element-81">
              55% of teachers will leave their positions sooner than planned.
              44% report burnout is constant.
            </p>

            <p className="text-lg md:text-xl font-semibold" data-id="element-82">
              The teachers who stay and love it build better systems early.
            </p>

            <p data-id="element-83">
              You became a music teacher to change lives. The Mega Music Pack
              makes sure the logistics never get in the way of that again.
            </p>
          </div>

          <div className="border-t-2 border-gold pt-8 md:pt-12 space-y-6 md:space-y-8" data-id="element-84">
            <p className="text-xl md:text-2xl lg:text-3xl font-bold text-center" data-id="element-85">
              Your students deserve a teacher who shows up fully present.
            </p>
            <p className="text-xl md:text-2xl lg:text-3xl font-bold text-center" data-id="element-86">
              Your family deserves the Sunday nights back.
            </p>
            <p className="text-xl md:text-2xl lg:text-3xl font-bold text-center" data-id="element-87">
              You deserve to love what you do.
            </p>
          </div>

          <div className="mt-8 md:mt-12 flex flex-col items-center space-y-4 md:space-y-6" data-id="element-88">
            <CtaButton className="text-lg md:text-xl px-10 md:px-12 py-5 md:py-6" data-id="element-89">
              GET INSTANT ACCESS — $17
            </CtaButton>
            <div className="text-center space-y-1 md:space-y-2 text-sm md:text-base" data-id="element-90">
              <p data-id="element-91">Everything downloads immediately.</p>
              <p data-id="element-92">Open your grade level.</p>
              <p data-id="element-93">Start with this week's lesson.</p>
              <p className="text-lg md:text-xl font-semibold text-gold-light mt-3 md:mt-4" data-id="element-94">
                You are ready.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}